<ng-container *ngIf="formRef?.control as formRefControl">
  <form [formGroup]="formRefControl" class="batch-form cmn-forms">
    <div class="formContainer contactInfoForm">
      <div class="formContainer__formSection " formGroupName="contact">
        <h1 class="formSection__header">Personal Information</h1>
        <div class="formSection__row ">
          <div class="formSection__input row--fullWidthInput">
            <h2 class="input__title">Full Name <span class="requiredIndicator">*</span></h2>
            <mat-form-field floatLabel="never">
              <input placeholder="Full Name" matInput type="text" formControlName="name" />
              <mat-error>{{ $any(formRefControl).controls.contact?.controls.name?.errors | formError }}</mat-error>
              <mat-icon
                *ngIf="
                  $any(formRefControl).controls.contact?.controls.name?.touched &&
                  !$any(formRefControl).controls.contact?.controls.name?.errors
                "
                class="validCheck"
                >check</mat-icon
              >
            </mat-form-field>
          </div>
        </div>
        <div class="formSection__row ">
          <div class="formSection__input row--fullWidthInput">
            <h2 class="input__title">Email ID<span class="requiredIndicator">*</span></h2>
            <mat-form-field floatLabel="never">
              <input placeholder="Email ID" matInput type="text" formControlName="email" />
              <mat-error>{{ $any(formRefControl).controls.contact?.controls.email?.errors | formError }}</mat-error>
              <mat-icon
                *ngIf="
                  $any(formRefControl).controls.contact?.controls.email?.touched &&
                  !$any(formRefControl).controls.contact?.controls.email?.errors
                "
                class="validCheck"
                >check</mat-icon
              >
            </mat-form-field>
          </div>
        </div>
        <div class="formSection__row extension--row">
          <div class="formSection__input">
            <h2 class="input__title">Phone<span class="requiredIndicator">*</span></h2>
            <mat-form-field floatLabel="never">
              <input placeholder="" matInput type="text" formControlName="phoneNumber" mask="(000) 000 - 0000" />
              <mat-error>{{ $any(formRefControl).controls.contact?.controls.phoneNumber?.errors | formError }}</mat-error>
              <mat-icon
                *ngIf="
                  $any(formRefControl).controls.contact?.controls.phoneNumber?.touched &&
                  !$any(formRefControl).controls.contact?.controls.phoneNumber?.errors
                "
                class="validCheck"
                >check</mat-icon
              >
            </mat-form-field>
          </div>

          <div class="formSection__input extension">
            <h2 class="input__title">Extension</h2>

            <mat-form-field floatLabel="never">
              <input placeholder="" matInput type="text" formControlName="extension" />
              <mat-error>{{ $any(formRefControl).controls.contact?.controls.extension?.errors | formError }}</mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="formContainer__formSection ">
        <h1 class="formSection__header">Billing Contact</h1>
        <div class="formSection__row ">
          <mat-checkbox class="cmn-chkbx" formControlName="billingAsCompanyContact" (change)="checkboxChanged($event)"
            >Same as above</mat-checkbox
          >
        </div>
        <ng-container formGroupName="billingContact">
          <div class="formSection__row ">
            <div class="formSection__input row--fullWidthInput">
              <h2 class="input__title">Full Name <span class="requiredIndicator">*</span></h2>
              <p *ngIf="billingContactSame" class="readOnlyContact">{{ this.formRef.value.contact.name }}</p>
              <mat-form-field *ngIf="!billingContactSame" floatLabel="never">
                <input placeholder="Full Name" matInput type="text" formControlName="name" />
                <mat-error>{{ $any(formRefControl).controls.billingContact?.controls.name?.errors | formError }}</mat-error>
                <mat-icon
                  *ngIf="
                    $any(formRefControl).controls.billingContact?.controls.name?.touched &&
                    !$any(formRefControl).controls.billingContact?.controls.name?.errors
                  "
                  class="validCheck"
                  >check</mat-icon
                >
              </mat-form-field>
            </div>
          </div>
          <div class="formSection__row ">
            <div class="formSection__input row--fullWidthInput">
              <h2 class="input__title">Email ID<span class="requiredIndicator">*</span></h2>
              <p *ngIf="billingContactSame" class="readOnlyContact">{{ this.formRef.value.contact.email }}</p>
              <mat-form-field *ngIf="!billingContactSame" floatLabel="never">
                <input placeholder="Email ID" matInput type="text" formControlName="email" />
                <mat-error>{{ $any(formRefControl).controls.billingContact?.controls.email?.errors | formError }}</mat-error>
                <mat-icon
                  *ngIf="
                    $any(formRefControl).controls.billingContact?.controls.email?.touched &&
                    !$any(formRefControl).controls.billingContact?.controls.email?.errors
                  "
                  class="validCheck"
                  >check</mat-icon
                >
              </mat-form-field>
            </div>
          </div>
          <div class="formSection__row extension--row ">
            <div class="formSection__input">
              <h2 class="input__title">Phone<span class="requiredIndicator">*</span></h2>
              <p *ngIf="billingContactSame" class="readOnlyContact">{{ this.formRef.value.contact.phoneNumber }}</p>
              <mat-form-field *ngIf="!billingContactSame" floatLabel="never">
                <input placeholder="" matInput type="text" formControlName="phoneNumber" mask="(000) 000 - 0000" />
                <mat-error>{{ $any(formRefControl).controls.billingContact?.controls.phoneNumber?.errors | formError }}</mat-error>
                <mat-icon
                  *ngIf="
                    $any(formRefControl).controls.billingContact?.controls.phoneNumber?.touchde &&
                    !$any(formRefControl).controls.billingContact?.controls.phoneNumber?.errors
                  "
                  class="validCheck"
                  >check</mat-icon
                >
              </mat-form-field>
            </div>
            <div class="formSection__input extension">
              <h2 class="input__title">Extension</h2>
              <p *ngIf="billingContactSame" class="readOnlyContact">{{ this.formRef.value.contact.extension }}</p>
              <mat-form-field *ngIf="!billingContactSame" floatLabel="never">
                <input placeholder="" matInput type="text" formControlName="extension" />
              </mat-form-field>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </form>
</ng-container>
